import { useState } from 'react';
import { axiosApi } from '../../api/setupApi';

const useUpdateNisMachineries = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const updateNisMachineries = async (id, data) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const response = await axiosApi.put(`/nisMachineries/update/${id}`, data);
      if (response && response.data && (response.status === 200 || response.status === 201)) {
        setSuccess(response.data.message || 'Machinery updated successfully.');
        return { success: true, message: response.data.message };
      }
      const msg = response.data?.error || 'Failed to update machinery.';
      setError(msg);
      return { success: false, message: msg };
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Update failed.';
      setError(msg);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  };

  return { updateNisMachineries, loading, error, success };
};

export default useUpdateNisMachineries;
